import type { TCreateContaResponse, TCreatePessoaJuridicaData } from '@/shared/interfaces/conta.types'
import { HttpService } from '@/shared/lib/http'

export class CriarPessoaJuridica extends HttpService {
  execute = async (pessoaJuridica: TCreatePessoaJuridicaData) => {
    const response = await this.http.post<TCreateContaResponse>(`/api/v2/Conta`, pessoaJuridica)
    return response.data
  }
}
